<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formNote">
        <div class="px-1 pb-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                (onClick)="goToBack($event)" [severity]="null" [width]="'6rem'"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [icon]="'pi pi-print'" [severity]="'contrast'"
                (onClick)="printPage()" [hidden]="isDocumentSupport"></app-custom-button>
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFileRequestNote [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
                [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
                hidden></app-custom-modal>
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                (onClick)="deleteNote()"></app-custom-button>
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewNote()"></app-custom-button>
              <app-custom-modal #selectRequestNote [label]="'Selección de Solicitud de Nota'"
                [header]="'Seleccionar Solicitud de Nota'" [children]="componentTableSelection"
                [inputs$]="inputsForRequestNoteModal$" [output$]="output$" [width]="'50rem'"
                (selectedItems)="generateNote($event)" hidden></app-custom-modal>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="noteContract.userNameCreate"
                [createDate]="noteContract.createDate" [userNameUpdate]="noteContract.userNameUpdate"
                [updateDate]="noteContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <!-- Formulario Captura -->
          <div class="row d-flex justify-content-between">
            <div class="col-lg-7 p-top mt-1">
              <div class="row d-flex align-items-end">
                <div class="custom-container col field-branch">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="custom-container col field-enterprise">
                  <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                    [required]="true" [recovery]="true"
                    (onChangeSelect)="getEnterprise($event, true)"></app-custom-select>
                </div>
                <div class="custom-container col field-request-consecutive">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="custom-container col field-type" *ngIf="!isDocumentSupport">
                  <app-custom-select formControlName="noteTypeId" [labelText]="'Tipo'" [list]="listNoteTypeFiltered"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeNoteType($event)"></app-custom-select>
                </div>
                <div class="custom-container col field-type-document" *ngIf="!isDocumentSupport">
                  <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo Doc.'"
                    [required]="true" [list]="listBussinessDocumentsTypes" [recovery]="true"
                    (onChangeSelect)="getBussinessDocumentsType($event, true)">
                  </app-custom-select>
                </div>
                <div class="custom-container col field-type-document" *ngIf="isDocumentSupport">
                  <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo Doc.'"
                    [required]="true" [list]="listBussinessDocumentsTypes" [recovery]="true"
                    (onChangeSelect)="getBussinessDocumentsType($event, true)">
                  </app-custom-select>
                </div>
                <div class="custom-container col field-state d-flex align-items-end">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState"
                    [value]="noteStateString"></app-custom-tag>
                  <div class="mx-1">
                    <label class="form-label"></label>
                    <div class="d-flex gap-1">
                      <app-custom-button [title]="titleStateNote" [icon]="iconStateNote"
                        (onClick)="changeStateNote()"></app-custom-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row d-flex align-items-end">
                <div class="custom-container col field-date">
                  <app-custom-datepicker formControlName="dateNote" [labelText]="'Fecha'" [required]="true">
                  </app-custom-datepicker>
                </div>
                <div class="custom-container col field-type" *ngIf="isDocumentSupport">
                  <app-custom-select formControlName="noteTypeId" [labelText]="'Tipo'"
                    [list]="listNoteTypeFiltered"></app-custom-select>
                </div>
                <div class="custom-container col field-level" *ngIf="!isDocumentSupport">
                  <app-custom-select formControlName="isLevelArticle" [labelText]="'Nivel'" [list]="listLevel"
                    [required]="true" (onChangeSelect)="changeLevel($event); changeValues()"></app-custom-select>
                </div>
                <div class="custom-container col field-level" *ngIf="isDocumentSupport">
                  <app-custom-select formControlName="isLevelArticle" [labelText]="'Nivel'" [list]="listLevel">
                  </app-custom-select>
                </div>
                <div class="custom-container col field-concept">
                  <app-custom-select formControlName="conceptId" [labelText]="'Concepto'" [required]="true"
                    [list]="listConcepts" (onChangeSelect)="getConcept($event)"></app-custom-select>
                </div>
                <div class="custom-container col field-operation-type" *ngIf="!isDocumentSupport">
                  <app-custom-select formControlName="operationTypeDian" [required]="true"
                    [labelText]="'Tipo Operación'" [list]="copyListOperationsTypeDian"
                    (onChangeSelect)="changeValues()"></app-custom-select>
                </div>
                <div class="col field-affectation">
                  <app-custom-tag [label]="'Afectación'" [value]="this.noteContract.valueToPay == this.totalValueInvoice 
                    ? 'Vr.Total' : this.noteContract.valueToPay < this.totalValueInvoice ? 'Vr.Parcial (Manual)' : ''">
                  </app-custom-tag>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <fieldset class="border mt-2">
                <div class="row px-1 p-top">
                  <div class="custom-container col field-invoice-consecutive" *ngIf="!isDocumentSupport">
                    <app-custom-input-number formControlName="invoiceConsecutive" [labelText]="'Factura'"
                      [required]="true" (onChangeNumber)="changeInvoice($event)">
                    </app-custom-input-number>
                  </div>
                  <div class="custom-container col field-support-document-type" *ngIf="isDocumentSupport">
                    <app-custom-input-number formControlName="invoiceConsecutive" [labelText]="'Doc. Afectado'"
                      [required]="true" (onChangeNumber)="changeDocumentSupport($event)">
                    </app-custom-input-number>
                  </div>
                  <div class="custom-container col field-type-document-invoice">
                    <app-custom-select [labelText]="isDocumentSupport ? 'Tipo Doc. Sop.' 
                      : 'Tipo Doc. Fra.'" [required]="true" [disabled]="disabledActions"
                      [formControl]="bussinessDocumentsTypeInvoiceForm" [list]="listBussinessDocumentsTypesInvoice"
                      (onChangeSelect)="getBussinessDocumentsTypeInvoice($event, true); changeValues()"></app-custom-select>
                  </div>
                  <div class="custom-container col field-date-invoice">
                    <app-custom-input-text [disabled]="true" [labelText]="'Fecha'" [value]="dateInvoice">
                    </app-custom-input-text>
                  </div>
                  <div class="custom-container col field-client-invoice" *ngIf="isDocumentSupport">
                    <app-custom-input-text [labelText]="'Proveedor'" [value]="codeNameProvider" [disabled]="true">
                    </app-custom-input-text>
                  </div>
                  <div class="custom-container col field-client-invoice" *ngIf="!isDocumentSupport">
                    <app-custom-input-text [labelText]="'Cliente'" [value]="codeNameClient" [disabled]="true"
                      [inputClass]="stateClientId !== 1 ? 'text-danger':''">
                    </app-custom-input-text>
                  </div>
                </div>
                <div class="row ps-1 mb-2">
                  <div class="custom-container col field-cost-center-invoice" *ngIf="!isDocumentSupport">
                    <app-custom-input-text [disabled]="true" [labelText]="'C.Costos'" [value]="codeNameCostCenter"
                      [inputClass]="stateCostCenterId !== 1 ? 'text-danger':''">
                    </app-custom-input-text>
                  </div>
                  <div class="custom-container col field-value-invoice">
                    <app-custom-input-decimal [disabled]="true" [labelText]="'Vr. Factura'" [value]="totalValueInvoice">
                    </app-custom-input-decimal>
                  </div>
                  <div class="custom-container col field-residue-invoice d-flex">
                    <app-custom-input-decimal [disabled]="true" [labelText]="'Saldo'"
                      [value]="residueValueInvoice"></app-custom-input-decimal>
                  </div>
                  <div class="col field-annul-button mt-1 d-flex align-items-end">
                    <div class="d-flex gap-1" [hidden]="noteContract.noteTypeId == 2">
                      <app-custom-button [title]="'Anular Fra.'" [icon]="'pi pi-ban'" [severity]="'warn'"
                        [disabled]="disabledActions || buttonAnnuls" (onClick)="annulInvoiceByNote()">
                      </app-custom-button>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-lg-7">
              <div class="row align-items-end">
                <div class="custom-container col field-observations">
                  <app-custom-input-text formControlName="observationPrint" [labelText]="'Observación(Imprime)'"
                    [maxLength]="500">
                  </app-custom-input-text>
                </div>
                <div class="custom-container col field-observations">
                  <app-custom-input-text formControlName="observation" [labelText]="'Observación'" [maxLength]="500">
                  </app-custom-input-text>
                </div>
                <div class="col field-save-button m-top">
                  <app-custom-button [title]="'Guardar Nota'" [label]="'Guardar'" [severity]="'primary'"
                    [disabled]="disabledSend" (onClick)="send()">
                  </app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style mt-2 pb-2">
    <app-note-detail #noteDetail [noteModel]="noteContract" [disabledActions]="disabledActions"
      [isDocumentSupport]="isDocumentSupport" [headerChanged]="headerChanged" (updateNote)="getUpdateNote($event)"
      (emitQuantityDetails)="onQuantityDetails($event)">
    </app-note-detail>
  </div>
  <form class="needs-validation mt-2 pt-1 pb-2 container-style" [formGroup]="formNoteTotals">
    <div class="col-lg-12 col-12">
      <div class="row">
        <div class="col-12 col-lg-7 col-md-12">
          <div class="row">
            <div class="col-12 col-lg-10 col-md-12">
              <fieldset class="border mt-1 p-1">
                <div class="row mb-2">
                  <div class="d-flex flex-wrap align-items-center">
                    <label class="label-style me-4 mb-0">Interfaz:
                      <span class="p-container">{{ electronicInvoiceInterfaceCode }}</span>
                    </label>
                    <label *ngIf="requestNoteActive" class="label-style me-4 mb-0">Solicitud:
                      <span class="p-container">{{ requestNoteConsecutive }}</span>
                    </label>
                    <label class="label-style mb-0">Interfaz Contable:
                      <span class="p-container">{{ accountingInterfaceCode }}</span>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <label class="label-style mb-0">CUDE:<span class="p-container">{{ cude }}</span></label>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-12">
          <div class="row d-flex justify-content-end">
            <div class="custom-container col-lg-3 col-md-3 col-sm-4 col-6" *ngIf="!isDocumentSupport">
              <app-custom-input-decimal formControlName="subtotalValue"
                [labelText]="'Subtotal'"></app-custom-input-decimal>
            </div>
            <div class="custom-container col-lg-3 col-md-3 col-sm-4 col-6" *ngIf="!isDocumentSupport">
              <app-custom-input-decimal formControlName="ivaValue" [labelText]="'Vr.Iva'"></app-custom-input-decimal>
            </div>
            <div class="custom-container col-lg-3 col-md-3 col-sm-4 col-6" *ngIf="!isDocumentSupport">
              <app-custom-input-decimal formControlName="totalValue" [labelText]="'Total'"></app-custom-input-decimal>
            </div>
            <div class="custom-container col-lg-3 col-md-3 col-sm-4 col-6">
              <app-custom-input-decimal formControlName="valueToPay"
                [labelText]="isDocumentSupport ? 'Total Nota' : 'Vr. A Pagar'"></app-custom-input-decimal>
            </div>
          </div>
          <div class="row" *ngIf="!isDocumentSupport">
            <div class="custom-container col-lg-3 col-md-3 col-sm-4 col-6">
              <app-custom-input-decimal formControlName="reteIvaValue"
                [labelText]="'Rte.Iva'"></app-custom-input-decimal>
            </div>
            <div class="custom-container col-lg-3 col-md-3 col-sm-4 col-6">
              <app-custom-input-decimal formControlName="reteFuenteValue"
                [labelText]="invoiceSwSelfRetainer ? 'Auto.Rte.Fuente' : 'Rte.Fuente' "
                [ngClass]="invoiceSwSelfRetainer ? 'text-red' : ''">
              </app-custom-input-decimal>
            </div>
            <div class="custom-container col-lg-3 col-md-3 col-sm-4 col-6">
              <app-custom-input-decimal formControlName="reteIcaValue"
                [labelText]="invoiceSwIcaSelfRetainer ? 'Auto.Rte.Ica' : 'Rte.Ica'"
                [ngClass]="invoiceSwIcaSelfRetainer ? 'text-red' : ''">
              </app-custom-input-decimal>
            </div>
            <div class="custom-container col-lg-3 col-md-3 col-sm-5 col-6" *ngIf="!isDocumentSupport">
              <app-custom-input-text [labelText]="'Moneda'" [ngClass]="codeCurrency != 'COP' ? 'text-danger' : ''"
                value={{codeCurrency}} [disabled]="true"></app-custom-input-text>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>
<!-- Imprimir Traslado Entre Obras -->
<div id="container-print-note">
  <app-print-note *ngIf="printNoteFormat" id="print-note" [companyId]="companyId"
    [isLevelArticle]="noteContract.isLevelArticle" [notePrintModel]="notePrintModel" [focusText]="true"
    [editFormat]="false" [formatModel]="formatModel" (finishLoadingPrintNote)="finishLoading($event)">
  </app-print-note>
</div>